import {
  updateOnlineUsers,
  updateChat,
  toggleChatBadge,
  updatePathData,
  // toggleAudio,
  // toggleVideo,
  // updateCanvasReconnect,
  emptyPathArray,
  clearCanvas,
  undoCanvas,
  updateHandRaiseQ,
  updateMyHandRaise,
  updateInHandRaiseQ,
  updateStudentPages,
  // updateClassConnected,
  updateAllPages,
  switchStudentCanvasAction
  // updateHandRaise,
  // allowCanvasSwitch,
  // updateScreenRecordingStatus
} from "actions/liveClass";

import message from 'antd/lib/message';
import 'antd/lib/message/style/index';

import {
  updateLocalMedia,
  updateRemoteMedia,
  updateActiveSpeaker
} from "actions/brigoshaMedia";

// import {
//   updateReconnectModal,
// } from "actions/common";

import { updateStartLoader } from "actions/today";

import { EventRegister } from "react-native-event-listeners";
import { BrigoshaMedia, Utils } from "services";

const initListeners = (user, isTeacher, joinRes) => (dispatch, getState) => {
  const { brigoshaMedia } = getState().brigoshaMedia;
  const { activeClass } = getState().today;

  EventRegister.addEventListener("mediaReady", roomInfo => {
    if (isTeacher) {
      brigoshaMedia.produce(BrigoshaMedia.MEDIA_TYPE.video);
    }
    brigoshaMedia.produce(BrigoshaMedia.MEDIA_TYPE.audio);
    dispatch(switchStudentCanvasAction(roomInfo.boardData.currentPage));
    dispatch(updateAllPages(roomInfo.boardData.pages));

    dispatch(updateHandRaiseQ(joinRes.handRequestQueue));
    dispatch(updateStartLoader(false));
    dispatch(updateClassConnected(true));
  });

  EventRegister.addEventListener("chatRcv", data => {
    if (typeof data.image !== "undefined") {
      dispatch(
        updateChat(
          Utils.sendMessage(
            data.text,
            data.user,
            { image: data.image },
            data.createdAt
          )
        )
      );
    } else {
      dispatch(
        updateChat(Utils.sendMessage(data.text, data.user, {}, data.createdAt))
      );
    }
    dispatch(toggleChatBadge(true));
  });

  EventRegister.addEventListener("userList", data => {
    dispatch(updateOnlineUsers(data));
  });

  EventRegister.addEventListener("userJoined", data => {
    if (data.user) {
      dispatch(
        updateChat(
          Utils.sendMessage(`${data.user.name} Joined`, data.user, {
            system: true
          })
        )
      );
      if (activeClass.teacher.id === data.user.id) {
        message.success("Teacher has joined the class");
      }
    }
    dispatch(updateOnlineUsers(data.users));
  });

  EventRegister.addEventListener("userLeft", data => {
    if (data.user) {
      dispatch(
        updateChat(
          Utils.sendMessage(`${data.user.name} Left`, data.user, {
            system: true
          })
        )
      );
      if (activeClass.teacher.id === data.user.id) {
        message.error("Teacher has left the class");
      }
    }
    dispatch(updateOnlineUsers(data.users));
  });

  // EventRegister.addEventListener("recordingStarted", () => {
  //   dispatch(updateScreenRecordingStatus(true));
  // });
  //
  // EventRegister.addEventListener("recordingStoped", () => {
  //   dispatch(updateScreenRecordingStatus(false));
  // });

  EventRegister.addEventListener("updateRaiseHandQueue", users => {
    dispatch(updateHandRaiseQ(users));
  });
  //
  // EventRegister.addEventListener("isHandRaiseActive", data => {
  //   console.log("isHandRaiseActive", data);
  //   // dispatch(updateHandRaise(data));
  // });

  EventRegister.addEventListener("disableHandRaise", () => {
    dispatch(toggleAudio(false));
    dispatch(toggleVideo(false));
    dispatch(updateMyHandRaise(false));
    dispatch(updateLocalMedia(false));
  });

  EventRegister.addEventListener("rejectHandRequestRcv", userId => {
    const { isMyHandRaise } = getState().liveClass;
    if (activeClass.teacher.id === userId && !isMyHandRaise) {
      message.error("Hand raise request rejected by the teacher");
    }
    // end call
    if (isMyHandRaise) {
      brigoshaMedia.closeProducer(BrigoshaMedia.MEDIA_TYPE.video);
      brigoshaMedia.pauseProducer(BrigoshaMedia.MEDIA_TYPE.audio);
      dispatch(toggleAudio(false));
      dispatch(toggleVideo(false));
      dispatch(updateMyHandRaise(false));
      dispatch(updateLocalMedia(false));
      message.success("Your doubt session with the teacher has ended");
    }
    dispatch(updateInHandRaiseQ(false));
  });
  //
  EventRegister.addEventListener("acceptHandRequestRcv", () => {
    const showMsg = {
      type: "success",
      text: "Hand raise request accepted. You are now on call."
    };
    message.success(showMsg.text);

    brigoshaMedia.produce(BrigoshaMedia.MEDIA_TYPE.video);
    brigoshaMedia.resumeProducer(BrigoshaMedia.MEDIA_TYPE.audio);
    dispatch(toggleVideo(true));
    dispatch(toggleAudio(true));
    dispatch(updateMyHandRaise(true));
  });
  //
  // const handleAcceptPressed = user => {
  //   brigoshaMedia.acceptHandRequest(user.id);
  // };
  //
  // const handleRejectPress = user => {
  //   brigoshaMedia.rejectHandRequest(user.id);
  // };
  //
  // EventRegister.addEventListener("raiseHandRequestRcv", user => {
  //   Alert.alert(
  //     "Hand Raise Request",
  //     `${user.name} has a doubt`,
  //     [
  //       {
  //         text: "Close",
  //         onPress: () => {},
  //         style: "cancel"
  //       },
  //       {
  //         text: "Reject",
  //         onPress: () => handleRejectPress(user)
  //       },
  //       { text: "Accept", onPress: () => handleAcceptPressed(user) }
  //     ],
  //     { cancelable: false }
  //   );
  // });

  EventRegister.addEventListener("boardDataRcv", data => {
    console.log("boardDataRcv", data);
    switch (data.type) {
      case "path":
        dispatch(updatePathData(data.data.path));
        break;
      case "clearCanvas":
        dispatch(emptyPathArray());
        dispatch(clearCanvas());
        break;
      case "undoCanvas":
        dispatch(undoCanvas());
        break;
      case "switchPage":
        dispatch(updateStudentPages(data.pageData.path, data.data, false));
        // dispatch(allowCanvasSwitch(true));
        break;
      default:
      // Do nothing
    }
  });

  EventRegister.addEventListener("localMedia", data => {
    console.log(data, "loc media");
    dispatch(updateLocalMedia(data));
  });
  EventRegister.addEventListener("audioReady", () => {
    if (!isTeacher) {
      brigoshaMedia.pauseProducer(BrigoshaMedia.MEDIA_TYPE.audio);
    }
  });
  EventRegister.addEventListener("remoteMedia", data => {
    console.log("in listener", data);
    dispatch(updateRemoteMedia(data));
  });
  EventRegister.addEventListener("activeSpeaker", data => {
    dispatch(updateActiveSpeaker(data));
  });
  EventRegister.addEventListener("mediaPause", type => {
    if (type === "audioType") {
      dispatch(toggleAudio(false));
    }
  });
  EventRegister.addEventListener("mediaResume", type => {
    if (type === "audioType") {
      dispatch(toggleAudio(true));
    }
  });
  // EventRegister.addEventListener("reconnect", data => {
  //   dispatch(updateReconnectModal(false));
  //   if (Object.keys(data.roomInfo.boardData).length !== 0) {
  //     dispatch(
  //       updateStudentPages(
  //         data.roomInfo.boardData.path,
  //         data.roomInfo.boardData.currentPage,
  //         true
  //       )
  //     );
  //     dispatch(updateCanvasReconnect(false));
  //   }
  //
  //   dispatch(updateHandRaiseQ(data.roomInfo.handRequestQueue));
  //
  //   if (!data.produce) {
  //     return;
  //   }
  //   if (isTeacher) {
  //     brigoshaMedia.produce(BrigoshaMedia.MEDIA_TYPE.video);
  //   }
  //   brigoshaMedia.produce(BrigoshaMedia.MEDIA_TYPE.audio);
  // });
  //
  // EventRegister.addEventListener("disconnect", () => {
  //   dispatch(updateReconnectModal(true));
  // });
};

export default initListeners;
